import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { macroExamService } from 'shared/services';
import toast from 'shared/utils/toast';
import MacroExamForm from '../components/MacroExamForm';
import { IMacroExam } from '../types';

export const EditMacroExam = () => {
  const translationPrefix = 'pages.macro-exams.edit';
  const { t } = useTranslation();
  const { macroExamId } = useParams();

  const [macroExam, setMacroExam] = useState<IMacroExam>();

  useEffect(() => {
    macroExamService.get(+macroExamId).then(setMacroExam);
  }, []);

  const update = async (values) => {
    macroExamService.update(macroExam.id, values).then(() => {
      toast.crud.successUpdate('Macro-esame');
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={macroExam?.code}>
      <MacroExamForm macroExam={macroExam} onSubmit={update} />
    </TenantPage>
  );
};

export default EditMacroExam;
